import React, { useRef, useState } from "react"; // Solo necesitamos useRef
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../../spinner";
import { Mensaje } from "../../mensajes2";
import { formatMoneda, validaMonto, seleccionarCampo, formatoMonto } from "../../../util/varios";
import moment from "moment";
import axios from "axios";

export const ModalAgregarDeudaComercio = (props) => {
    // Referencias para los inputs y selects
    let op = require('../../../../src/modulos/datos');
    const token = JSON.parse(sessionStorage.getItem("jwtToken"));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));
    const [visibleDet, setVisibleDet] = useState("hidden");
    const [desde, setDesde] = useState(0);
    const [activate, setActivate] = useState(false);

    const estimadaRef = useRef(null);
    const definitivaRef = useRef(null);
    const detImpuRef = useRef(null);
    const regularRef = useRef(null);
    const primeraQuincenaRef = useRef(null);
    const segundaQuincenaRef = useRef(null);
    const quincenaRef1 = useRef(null);
    const quincenaRef2 = useRef(null);
    const bolivaresRef = useRef(null);
    const unidadRef = useRef(null);
    const anioRef = useRef(null);
    const desdeRef = useRef(null);
    const hastaRef = useRef(null);
    const fechaPagoRef = useRef(null);
    const numFacturaRef = useRef(null);
    const montoRef = useRef(null);

    const [mensaje, setMensaje] = React.useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });

    // Arreglo de años (desde el año actual hasta 8 años atrás)
    const añoActual = new Date().getFullYear();
    const años = Array.from({ length: 9 }, (_, i) => añoActual - i); // [2023, 2022, ..., 2015]

    // Arreglo de meses (enero a diciembre)
    const meses = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const cancelar = () => {
        props.onHide(); // Cierra el modal
    };

    const aceptar = () => {
        var sigue = true;
        let declaweb = false;
        let periodo = 1;
        let nomTabla = "";
        let nomIdContri = "";
        let nomIdDeuda = "";
        switch (props.tipo) {
            case "comercio":
                nomTabla = "deudacomercio";
                nomIdContri = "idcomercio";
                nomIdDeuda = "iddeudacomercio";
                declaweb = props.config.declaracionweb;
                break;
            case "inmueble":
                nomTabla = "deudainmueble";
                nomIdContri = "idinmueble";
                nomIdDeuda = "iddeudainmueble";
                declaweb = props.config.declaracionweb;
                break;
            case "vehiculo":
                nomTabla = "deudavehiculo";
                nomIdContri = "idvehiculo";
                nomIdDeuda = "iddeudavehiculo";
                declaweb = props.config.declaracionweb;
                break;
            case "rentas":
                nomTabla = "deudarentas";
                nomIdContri = "idrentas";
                nomIdDeuda = "iddeudarentas";
                declaweb = props.config.declaracionweb;
                break;
            case "apuestas":
                nomTabla = "deudaapuesta";
                nomIdContri = "idcomercio";
                nomIdDeuda = "iddeudaapuesta";
                break;
        }
        switch (parseInt(props.config.periodopago)) {
            case 1:
                periodo = 12;
                break;
            case 2:
                periodo = 3;
                break;
            case 3:
                periodo = 1;
                break;
        }
        if (desdeRef.current.value > hastaRef.current.value) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El mes de inicio no debe ser mayor al mes de fin.', icono: 'informacion' });
            sigue = false;
            desdeRef.current.focus();
        } else if (montoRef.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el monto.', icono: 'informacion' });
            sigue = false;
            montoRef.current.focus();
        } else if (parseFloat(montoRef.current.value) === 0.00 && props.operacion === 1) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Monto no Debe ser Igual a Cero.', icono: 'informacion' });
            sigue = false;
            montoRef.current.focus();
        } else if ((props.operacion === 1 || props.operacion === 2) && espiritu === 0 && !detImpuRef.current.checked && !primeraQuincenaRef.current.checked && !segundaQuincenaRef.current.checked) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar un tipo de Deuda.', icono: 'informacion' });
            sigue = false;
            detImpuRef.current.focus();
        } else if (espiritu === 0 && !detImpuRef.current.checked && (props.operacion === 3 && !regularRef.current.checked) && !primeraQuincenaRef.current.checked && !segundaQuincenaRef.current.checked) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar un tipo de Deuda.', icono: 'informacion' });
            sigue = false;
            detImpuRef.current.focus();
        } else if (espiritu !== 0 && !detImpuRef.current.checked && !regularRef.current.checked) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar un tipo de Deuda.', icono: 'informacion' });
            sigue = false;
            detImpuRef.current.focus();
        } else if (espiritu === 0 && detImpuRef.current.checked && !quincenaRef1.current.checked && !quincenaRef2.current.checked) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar un tipo de Deuda de la Determinacion deImpuesto.', icono: 'informacion' });
            sigue = false;
            quincenaRef1.current.focus();
        }
        if (props.operacion === 3 && sigue) {
            if (fechaPagoRef.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el la Fecha de pago.', icono: 'informacion' });
                sigue = false;
                fechaPagoRef.current.focus();
            } else if (numFacturaRef.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Introducir el Numero de la Factura.', icono: 'informacion' });
                sigue = false;
                numFacturaRef.current.focus();
            }
        }
        if (sigue) {
            let tipdec = 1;
            if (detImpuRef.current.checked) {
                if (espiritu === 0) {
                    if (quincenaRef1.current.checked) {
                        tipdec = 5;
                    } else {
                        tipdec = 6;
                    }
                } else {
                    tipdec = 5;
                }

            } else if (espiritu === 0 && primeraQuincenaRef.current.checked) {
                tipdec = 3;
            } else if (espiritu === 0 && segundaQuincenaRef.current.checked) {
                tipdec = 4;
            } else {
                tipdec = 0;
            }
            //setActivate(true);
            let nmonto = 0.00;
            if (props.operacion < 3 && bolivaresRef.current.checked) {
                nmonto = parseFloat(montoRef.current.value.replace(/\./g, "").replace(",", "."), 4) / parseFloat(props.factorcambio);
            } else {
                nmonto = parseFloat(montoRef.current.value.replace(/\./g, "").replace(",", "."), 4);
            }
            let body = {
                operacion: props.operacion,
                id: parseInt(props.contribuyente.idcontribuyente),
                nomtab: nomTabla,
                nomid: nomIdContri,
                peri: periodo,
                monto: nmonto,
                nanio: parseInt(anioRef.current.value),
                mesdesde: parseInt(desdeRef.current.value),
                meshasta: parseInt(hastaRef.current.value),
                nomiddeu: nomIdDeuda,
                tipo: tipdec,
                declaweb: declaweb,
                idusu: JSON.parse(localStorage.getItem("idusuario")),
                fechasis: JSON.parse(localStorage.getItem("fechasistema")),
                fechareal: JSON.parse(localStorage.getItem("fechareal")),
                fechapago: props.operacion === 3 ? fechaPagoRef.current.value : null,
                numrecibo: props.operacion === 3 ? numFacturaRef.current.value : null,
            };
            //alert(JSON.stringify(body))
            crearAjustarDeuda(body);
        }
    };

    const crearAjustarDeuda = (body) => {
        setActivate(true);
        let endpoint = `${op.conexion}/api/comun/creardeuda/${props.operacion}`;
        axios
            .post(endpoint, body, {
                headers: {
                    "x-access-token": `${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    if (response.data) {
                        setActivate(false);
                        setDesde(1);
                        if (props.operacion === 1) {
                            setMensaje({
                                mostrar: true,
                                titulo: "Exito.",
                                texto:
                                    "La Deuda ha sido Creada de manera satisfactoria.",
                                icono: "informacion",
                            });
                        } else if (props.operacion === 2) {
                            setMensaje({
                                mostrar: true,
                                titulo: "Exito.",
                                texto:
                                    "La Deuda ha sido ajustada de manera satisfactoria.",
                                icono: "informacion",
                            });
                        } else if (props.operacion === 3) {
                            setMensaje({
                                mostrar: true,
                                titulo: "Exito.",
                                texto:
                                    "La Deuda ha sido Actualizada de manera satisfactoria.",
                                icono: "informacion",
                            });
                        }

                    }
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        setDesde(0);
        props.onHideAcepta();
    };

    const handleInputMontoChange = (event) => {
        //event.preventDefault();
        validaMonto(event);
        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.0) {
            event.target.value = "0,00";
        }
        if (event.which >= 37 && event.which <= 40) {
            event.preventDefault();
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            event.target.value = (formatoMonto(event.target.value));
            if (event.which === 13) {
                montoRef.current.focus();
            }


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);

    };

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}

            onShow={() => {
                console.log(props.operacion)
                montoRef.current.value = formatMoneda(props.contribuyente.montoimpu.toString().replace(".", ","), ",", ".", 2);
                if (props.operacion === 3) {
                    fechaPagoRef.current.value = moment.utc(props.fechaSistema).format("YYYY-MM-DD");
                }

            }}
        >
            <Modal.Header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant rounded-top text-light">
                <h3 className="my-auto">{props.operacion === 1 ? 'Creacion de Deuda' : props.operacion === 2 ? 'Ajuste de Deuda' : 'Actualizar Deuda'}</h3>
                <a
                    type="button"
                    className="fw-bold text-light fs-6"
                    onClick={cancelar}
                >
                    Salir <i className="fa fa-times ms-2"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
                <div className="col-md-12 mx-auto row rounded p-0 my-0">
                    {props.tipo === 'comercio' && props.operacion === 1 || props.operacion === 2 || props.operacion === 3 ? <fieldset className="row border-azul rounded mx-auto col-sm-12 mb-1">
                        <legend className="float-none m-0 w-auto">Tipo Deuda</legend>
                        {/*{props.operacion !== 3 ?*/}
                        
                        <div className="form-check ml-2 mb-2 col-md-7">
                            <input
                                className="form-check-input my-auto"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault4"
                                ref={detImpuRef} // Referencia para el radio "Regular"
                                onChange={() => setVisibleDet("visible")}
                            />
                            <label className="form-check-label my-auto" htmlFor="flexRadioDefault4">
                                Determinacion de Impuesto
                            </label>
                        </div>
                        {/*: ''}*/}
                        {props.operacion === 3 && espiritu === 0 ?
                            <div className="form-check mx-auto mb-1 col-md-3">
                                <input
                                    className="form-check-input my-auto"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id="flexRadioDefault4"
                                    ref={regularRef} // Referencia para el radio "Regular"
                                    onChange={() => setVisibleDet("hidden")}
                                />
                                <label className="form-check-label my-auto" htmlFor="flexRadioDefault4">
                                    Regular
                                </label>
                            </div>
                            : ''}
                        <div className="form-check mx-auto mb-1 col-md-6">
                            <input
                                className="form-check-input my-auto"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault5"
                                ref={primeraQuincenaRef} // Referencia para el radio "Primera Quincena"
                                onChange={() => setVisibleDet("hidden")}
                            />
                            <label className="form-check-label my-auto" htmlFor="flexRadioDefault5">
                                {espiritu === 0 ? "Primera Quincena" : "Regular"}
                            </label>
                        </div>
                        {espiritu === 0 ?
                            <div className="form-check mx-auto mb-1 col-md-5 pr-0'">
                                <input
                                    className="form-check-input my-auto"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id="flexRadioDefault6"
                                    ref={segundaQuincenaRef} // Referencia para el radio "Segunda Quincena"
                                    onChange={() => setVisibleDet("hidden")}
                                />
                                <label className="form-check-label my-auto" htmlFor="flexRadioDefault6">
                                    Segunda Quincena
                                </label>
                            </div>
                            : ''}
                        <div className="form-check pl-4 pr-0 mt-1 mx-auto mb-1 col-md-6 " style={{ visibility: detImpuRef.current && detImpuRef.current.checked && espiritu === 0 ? "visible" : "hidden" }}>
                            <input
                                className="form-check-input my-auto"
                                type="radio"
                                name="radioQuincena"
                                id="radioQuincena1"
                                ref={quincenaRef1} // Referencia para el radio "Primera Quincena"
                            />
                            <label className="form-check-label my-auto" htmlFor="flexRadioDefault5">
                                1era Quincena Determinacion
                            </label>
                        </div>
                        <div className="form-check mx-auto mb-1 mt-1 col-md-6 pr-0'" style={{ visibility: detImpuRef.current && detImpuRef.current.checked && espiritu === 0 ? "visible" : "hidden" }}>
                            <input
                                className="form-check-input my-auto"
                                type="radio"
                                name="radioQuincena"
                                id="radioQuincena2"
                                ref={quincenaRef2} // Referencia para el radio "Segunda Quincena"
                            />
                            <label className="form-check-label my-auto" htmlFor="flexRadioDefault6">
                                2da Quincena Determinacion
                            </label>
                        </div>

                    </fieldset> : ''}

                    {props.operacion === 1 || props.operacion === 2 ?
                        <div className="row border-azul rounded mx-auto col-sm-12 mb-1 py-1">

                            <div className="form-check mb-1 col-md-6 my-auto">
                                <input
                                    className="form-check-input my-auto"
                                    type="radio"
                                    name="radioMoneda"
                                    id="radioMoneda1"
                                    defaultChecked
                                    ref={bolivaresRef}
                                />
                                <label className="form-check-label my-auto" htmlFor="flexRadioDefault1">
                                    Bolivares
                                </label>
                            </div>
                            <div className="form-check mb-1 col-md-6 my-auto">
                                <input
                                    className="form-check-input my-auto"
                                    type="radio"
                                    name="radioMoneda"
                                    id="radioMoneda2"
                                    ref={unidadRef}
                                />
                                <label className="form-check-label my-auto" htmlFor="flexRadioDefault2">
                                    Unidad de Cambio
                                </label>
                            </div>

                        </div>
                        : ''}

                    <fieldset className="row border-azul rounded mx-auto col-sm-12 mb-1">
                        <legend className="float-none m-0 w-auto">Periodo Comprendido Desde</legend>
                        <div className="input-group input-group-sm px-0 mb-1 col-md-4">
                            <span className="input-group-text">Año:</span>
                            <select
                                className="form-select"
                                aria-label="Default select example"
                                ref={anioRef} // Referencia para el select "Año"
                            >
                                {años.map((año) => (
                                    <option key={año} value={año}>
                                        {año}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="input-group input-group-sm px-0 mb-1 col-md-8"></div>
                        <div className="input-group input-group-sm px-0 mb-1 col-md-6">
                            <span className="input-group-text">Desde:</span>
                            <select
                                className="form-select"
                                aria-label="Default select example"
                                ref={desdeRef} // Referencia para el select "Desde"
                            >
                                {meses.map((mes, index) => (
                                    <option key={index} value={index + 1}>
                                        {mes}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="input-group input-group-sm px-0 mb-1 col-md-6">
                            <span className="input-group-text">Hasta:</span>
                            <select
                                className="form-select"
                                aria-label="Default select example"
                                ref={hastaRef} // Referencia para el select "Hasta"
                            >
                                {meses.map((mes, index) => (
                                    <option key={index} value={index + 1}>
                                        {mes}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </fieldset>
                    {props.operacion === 3 ?
                        <div className="input-group input-group-sm mb-1 px-0 col-md-6">
                            <span className="input-group-text">Fecha de Pago:</span>
                            <input
                                type="date"
                                className="form-control text-uppercase"
                                ref={fechaPagoRef} // Referencia para el input "Fecha de Pago"
                            />
                        </div> : ''}

                    {props.operacion === 3 ? <div className="input-group input-group-sm mb-1 px-0 col-md-6">
                        <span className="input-group-text">N° Factura:</span>
                        <input
                            type="text"
                            className="form-control text-uppercase"
                            ref={numFacturaRef} // Referencia para el input "N° Factura"
                        />
                    </div> : ''}

                    <div className="input-group input-group-sm mb-1 px-0 col-md-6 ml-0">
                        <span className="input-group-text">Monto:</span>
                        <input
                            type="text"
                            className="form-control text-uppercase"
                            style={{ textAlign: "right" }}
                            ref={montoRef} // Referencia para el input "Monto"
                            onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="row col-md-12">
                    <button
                        type="button"
                        style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
                        className="col-md-3 fw-bold btn btn-success btn-sm rounded-pill"
                        onClick={aceptar}
                    >
                        <i className="fas fa-check-circle"></i> Aceptar
                    </button>
                    <button
                        type="button"
                        style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
                        className="col-md-3 fw-bold btn btn-danger btn-sm rounded-pill"
                        onClick={cancelar}
                    >
                        <i className="fas fa-trash"></i> Cancelar
                    </button>
                </div>
            </Modal.Footer>
            <Dimmer active={activate} /> {/* Dimmer desactivado por defecto */}
            <Mensaje
                mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === "Exito."
                        ? cerrarModal()
                        : setMensaje({
                            mostrar: false,
                            titulo: "",
                            texto: "",
                            icono: "",
                        });
                }}
            />
        </Modal>
    );
};